import axios from "axios";
import { Notification } from "element-ui";
import defaultStringify from "./stringify";
import errCodes from "./code";
import i18n from "@/i18n";
import { getBusinessId } from "@/lib/auth";

let client;
let currentPrefix; // init 默认使用上一次的 prefix
let currentHeaders;
export const getPreFix = () => {
    return currentPrefix;
};

export function getApiDomain() {
    /*
    测试环境（本机与测试环境保持一致）：
        动态api域名：test-vlinkopenapi.cros.garena.com
        静态域名：test-vlink.cros.garena.com
    预发布环境：
        动态api域名：pre-vlinkopenapi.cros.garena.com
        静态域名：pre-vlink.cros.garena.com
    正式环境：
        动态api域名：vlink.cros.garena.com
        静态域名：vlinkopenapi.cros.garena.com
    */
    let before;
    switch (document.domain) {
        case "vlink.cros.garena.com":
            return "//vlinkopenapi.cros.garena.com";
        case "pre-vlink.cros.garena.com":
            before = "pre-";
            break;
        case "test-vlink.cros.garena.com":
        default:
            // 保险起见，我们默认对接测试环境
            before = "test-";
            break;
    }
    return `//${before}vlinkopenapi.cros.garena.com`;
}
export function init({ baseURL: prefix = currentPrefix, headers = {}, timeout = 15000 }) {
    const baseURL = prefix ? prefix : getApiDomain();
    currentPrefix = baseURL;
    currentHeaders = {
        "Content-Type": "application/x-www-form-urlencoded",
        ...headers
    };
    client = axios.create({
        baseURL,
        responseType: "json",
        withCredentials: true,
        timeout,
        headers: currentHeaders
    });
}
function setAjaxPrefix(prefix = process.env.VUE_APP_MOCK) {
    init({ baseURL: prefix });
}
setAjaxPrefix();
window.setAjaxPrefix = setAjaxPrefix;

function handleResp(response = { status: 500, statusText: "Network Error" }) {
    const errInfo = {};
    const errObj = { response, errInfo };
    if (200 !== response.status) {
        errInfo.title = i18n.t("all.ajax_error_title");
        errInfo.message = `[${response.status}] ${response.statusText}`;
    } else {
        const { err_code: code, result } = response.data || {};
        switch (code) {
            case 0:
                return result;
            default: {
                const errDesc = errCodes[code] || errCodes[10001];
                errObj.code = code;
                if ("function" === typeof errDesc) {
                    errInfo.message = errDesc();
                } else {
                    const { title, message, action } = errDesc;
                    errInfo.title = title;
                    errInfo.message = message();
                    if (false === (action && action())) {
                        errInfo.disabled = true;
                    }
                }
            }
        }
    }
    errInfo.disabled || Notification.error(errInfo);
    throw errObj;
}

function isString(input) {
    return "string" === typeof input;
}

function isFormData(form) {
    return form instanceof FormData;
}

// 多业务，所有请求加business_id参数
function addBusinessIdParam(param = {}) {
    if (!isString(param)) {
        param.business_id = getBusinessId();
    }

    if (isFormData(param)) {
        param.append("business_id", getBusinessId());
    }

    return param;
}

export async function get(path, param, { stringify = defaultStringify } = {}) {
    const paramWithBusiness = addBusinessIdParam(param);
    const query = stringify(paramWithBusiness);
    if (!isString(query)) {
        throw new Error("GET 类型不能传递文件之类的数据噢");
    }
    let response;
    try {
        response = await client.get(`${path}${undefined === query ? "" : `?${query}`}`);
    } catch (err) {
        response = err.response;
    }
    const result = handleResp(response);
    return result;
}

export async function post(url, param, { stringify = defaultStringify } = {}) {
    let response;
    const paramWithBusiness = addBusinessIdParam(param);
    const data = stringify(paramWithBusiness);
    try {
        response = await client({
            method: "post",
            url,
            data,
            headers: {
                ...currentHeaders,
                "Content-Type": isString(data) ? "application/x-www-form-urlencoded" : "multipart/form-data"
            }
        });
    } catch (err) {
        response = err.response;
    }
    const result = handleResp(response);
    return result;
}

export default { get, post, defaultStringify };
